<div class="row g-3 mt-3">
    <div class="col-sm-6 mb-3">
        <label for="startDate" class="form-label">Fecha inicio</label>
        <input type="date" id="startDate" [(ngModel)]="startDate" (change)="onChangeDate()" class="form-control" />
    </div>

    <!-- Fecha fin -->
    <div class="col-sm-6 mb-3">
        <label for="endDate" class="form-label">Fecha final</label>
        <input type="date" id="endDate" [(ngModel)]="endDate" (change)="onChangeDate()" class="form-control" />
    </div>
    <div class="col-sm-6 form-group mb-3">
        <label for="bankAccountDebit" class="form-label fw-semibold">Buscar por</label>
        <select class="form-select" [(ngModel)]="historialFilter">
            <option [ngValue]="0">Todos</option>
            <option [ngValue]="1">Por Afiliado</option>
        </select>
    </div>
    <div class="col-sm-6 mb-3" *ngIf="historialFilter == 1">
        <div class="mb-3">
            <label class="form-label fw-semibold">Afiliado</label>
            <div class="input-group input-group-sm">
                <app-input-autocomplete
                [ruleToDisabled]="affiliates.length == 0"
                [allBorderRadius]="true"
                [inputs]="affiliateInput"
                [placeholder]="'Ingresa el NIT o nombre del Afiliado'"
                [filterElements]="affiliateInput.filterElements"
                (inputMethod)="writeClient()"
                (changeStatus)="selectAffiliate($event.filterElement)"
                [custom]="true">
                <ng-template #itemsTemplate let-filter>
                    <div items>
                    <h6 class="text-info mb-0">{{filter.nombre}} {{filter.apellido}}</h6>
                    <small class="text-white">Codigo: <b>{{filter.code}}</b> . NIT: <b>{{filter.nit}}</b></small>
                    </div>
                </ng-template>
                </app-input-autocomplete>
            </div>
        </div>
    </div>
</div>

<div class="table-responsive" style="margin-top: -1px;">
    <table class="table table-bordered" style="margin: 0;">
        <thead>
            <tr>
                <th class="td-center">
                    Fecha
                </th>
                <!-- <th class="td-center">
                    Tipo
                </th> -->
                <th class="td-center">
                    Factura
                </th>
                <th class="td-center">
                    Affiliado
                </th>
                <th class="td-center">
                    Puntos (+/-)
                </th>
                <th class="td-center">
                    Nuevo Valor Puntos
                </th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let item of pagination.filter">
                <tr>
                    <td>{{item.affiliatePointHistory.creationAt | date:'dd-MM-YYYY HH:mm'}}</td>
                    <td>{{item.clientInvoice.series}} - {{item.clientInvoice.number}}</td>
                    <td>{{item.affiliate.nombre}} {{item.affiliate.apellido}}</td>
                    <td class="text-right">
                        <span class="text-right" [classList]="item.affiliatePointHistory.type==0? 'text-success' : 'text-danger'">
                            {{item.affiliatePointHistory.type==0 ? '(+) ' : '(-) '}} {{item.affiliatePointHistory.points}}
                        </span>
                    </td>
                    <td class="text-right">{{item.affiliatePointHistory.newPoints}}</td>
                </tr>
                <tr *ngIf="pagination.filter.length === 0">
                    <td colspan="8" class="text-center text-muted">
                    <i class="fa fa-circle-info"></i> No se encontraron transferencias en el rango seleccionado
                    </td>
                </tr>
            </ng-container>
            <tr class="tr-middle" *ngIf="loading">
                <td colspan="8" class="">
                    <span class="display-5 text-center">
                        <app-loading-animation [height]="'3rem'"></app-loading-animation>
                        Cargando...
                    </span>
                </td>
            </tr>
        </tbody>
    </table>
    <app-pagination-custom [elements]="pagination"></app-pagination-custom>
</div>
